import styled, { Interpolation } from 'styled-components';

type props = {
	styles?: Interpolation<React.CSSProperties>
}
const InputStyle = styled.input<props>`
	background: var(--inputBGOpacity);
  appearance: none;
  border: 1px solid var(--borderLightColor);
  padding: 0.75em;
  border-radius: 8px;
	width: 100%;
  display: block; 
	font-size: 14px;
	color: var(--textColor);
	${({ styles }) => styles}
	&:disabled {
		opacity: 0.9 !important;
		cursor: not-allowed;
  }
	&[type="number"] {
		color-scheme: var(--colorScheme, light);
	}
}
	&.input-annual-usage{
		padding: 0.484rem 0.65rem;
		line-height: 1.35;
	}
	&.input-annual-usage,&.input-bill{
		padding: 0.484rem 0.65rem;
		line-height: 1.35;
	}	
`;

export {
	InputStyle
};